import React from "react";
import { bool, string, object } from "prop-types";
import cx from "classnames";

import ArrowLink from "../../ArrowLink/ArrowLink.jsx";

const propTypes = {
  darkTheme: bool,
  backgroundColor: string,
  value: string.isRequired,
  description: string,
  link: object,
};

const GlobalNavStat = (props) => {
  const { darkTheme, backgroundColor, value, description, link } = props;

  return (
    <section
      className={cx("global-nav-stat", {
        "global-nav-stat--dark": darkTheme,
        "global-nav-stat--has-background": backgroundColor,
      })}
      style={
        backgroundColor ? { ["--background-color"]: backgroundColor } : null
      }
    >
      <div className="global-nav-stat__value">{value}</div>
      {description && (
        <div className="global-nav-stat__description">{description}</div>
      )}
      {link && (
        <div className="global-nav-stat__link">
          <ArrowLink {...link} gtmElementLabel={"global nav stat link"} />
        </div>
      )}
    </section>
  );
};
GlobalNavStat.propTypes = propTypes;
export default GlobalNavStat;
